import React from 'react';
import { ApplicationCardData } from '../../../apis/JobPortalService';
import mapPin from '../../../assets/images/icons/mapPin.svg';
import money from '../../../assets/images/icons/money.svg';
import positions from '../../../assets/images/icons/positions.svg';
import { PopupState } from '../jobportal';

interface ApplicationCardProps {
	data: ApplicationCardData;
	setJobDetailsPopup: (newState: PopupState) => void;
}

const ApplicationCard = ({
	data,
	setJobDetailsPopup,
}: ApplicationCardProps) => {
	let {
		companyName,
		location,
		minCtcOffered,
		maxCtcOffered,
		noOfPositions,
		currentStage,
		jobCardId,
	} = data;

	const locationString =
		location.constructor === Array ? location.join(', ') : '';

	const stageStyle = {
		color: '#2f80ed',
		backgroundColor: '#dcebff',
		border: '1px solid',
		borderColor: '#2f80ed',
	};
	if (currentStage.includes('rejected')) {
		stageStyle.color = '#e74c3c';
		stageStyle.borderColor = '#e74c3c';
		stageStyle.backgroundColor = '#FDE6E4';
	} else if (currentStage.includes('selected')) {
		stageStyle.color = '#12b76a';
		stageStyle.borderColor = '#12b76a';
		stageStyle.backgroundColor = '#E3FFED';
	} else if (currentStage.includes('hold')) {
		stageStyle.color = '#ff940a';
		stageStyle.borderColor = '#ff940a';
		stageStyle.backgroundColor = 'rgba(253, 242, 214, 0.5)';
	} else {
		currentStage = 'Current Stage - ' + currentStage;
	}

	return (
		<div className="application-card">
			<div className="header-area">
				<div className="company-overview">
					<h3>{companyName}</h3>

					<p style={stageStyle}>{currentStage}</p>
				</div>
				<div className="deadline"></div>
			</div>
			<div className="body-area">
				{noOfPositions && (
					<div>
						<img src={positions} /> {noOfPositions} Open Positions
					</div>
				)}
				{location && (
					<div
						className={location.length > 1 ? 'custom-tooltip' : ''}
						data-tooltip={locationString}
					>
						<img src={mapPin} />
						{location.length > 1
							? 'Multiple Locations'
							: location[0]}
					</div>
				)}
				{minCtcOffered && maxCtcOffered && (
					<div>
						<img src={money} />{' '}
						{minCtcOffered + 'LPA - ' + maxCtcOffered + 'LPA'}
					</div>
				)}
				<button
					onClick={() => {
						setJobDetailsPopup({
							isOpen: true,
							identifier: jobCardId + 'source:applications',
						});
					}}
				>
					More details
				</button>
			</div>
		</div>
	);
};

export default ApplicationCard;
